import { render, staticRenderFns } from "./Recommends.vue?vue&type=template&id=7cdaab20&scoped=true"
import script from "./Recommends.vue?vue&type=script&lang=ts"
export * from "./Recommends.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Recommends.vue?vue&type=style&index=0&id=7cdaab20&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7cdaab20",
  "d888e778"
  
)

export default component.exports